import useAnswerFeedback from './useAnswerFeedback.hook';

export default function AnswerFeedback() {
  useAnswerFeedback();
  return null;
}
